<template>
  <v-app>
    <v-app-bar app color="dark" dark>
      <v-toolbar-title>
        Layout Labelling
        <span class="text-caption ml-3" style="opacity:0.75">Training</span>
      </v-toolbar-title>
    </v-app-bar>
    <v-main>
      <v-container>
        <v-row justify="center">
          <v-col cols="12" md="10">
            <v-card class="pa-6">
              <v-card-title class="text-h5">
                Training Video: How to Find the Shortest Path Length
              </v-card-title>
              <v-alert type="info" dense text class="mb-4">
                Please watch this video to the end. The Continue button unlocks when it finishes.
              </v-alert>
              <video
                ref="vid"
                class="training-video"
                controls
                controlslist="nodownload noplaybackrate"
                preload="auto"
                @contextmenu.prevent
                @ended="onEnded"
                @timeupdate="onTimeUpdate"
                @seeking="onSeeking"
              >
                <source src="/pilot/training_video.mp4" type="video/mp4" />
              </video>
              <div class="text-center mt-4">
                <v-btn class="ma-2" outlined color="primary" @click="play">Play</v-btn>
                <v-btn class="ma-2" outlined color="primary" :disabled="!ended" @click="replay">
                  Watch again
                </v-btn>
                <v-btn
                  class="ma-2"
                  color="primary"
                  large
                  :disabled="!ended"
                  :loading="loading"
                  @click="continueToPractice"
                >
                  Continue to practice trials
                </v-btn>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import config from '@/config';

export default {
  name: 'TrainingVideo',
  data() {
    return {
      sessionId: this.$route.params.sessionId,
      ended: false,
      loading: false,
      lastT: 0,
      allowSeek: false,
    };
  },
  methods: {
    play() {
      this.$refs.vid && this.$refs.vid.play();
    },
    replay() {
      const v = this.$refs.vid;
      if (!v) return;
      // Seeking to 0 is intentional after first full watch
      this.allowSeek = true;
      this.lastT = 0;
      const start = () => {
        v.currentTime = 0;
        const p = v.play();
        if (p && typeof p.catch === 'function') p.catch(() => {});
      };
      // If ended, some browsers need a tiny delay before seeking restarts cleanly
      if (v.ended) {
        this.$nextTick(start);
      } else {
        start();
      }
    },
    onEnded() {
      this.ended = true;
      this.allowSeek = true;
    },
    onTimeUpdate() {
      if (this.$refs.vid) this.lastT = this.$refs.vid.currentTime;
    },
    onSeeking() {
      // Block skip-ahead only before the first complete watch
      if (this.allowSeek || this.ended) return;
      const v = this.$refs.vid;
      if (!v) return;
      if (Math.abs(v.currentTime - this.lastT) > 1) {
        v.currentTime = this.lastT;
      }
    },
    async continueToPractice() {
      if (!this.ended || this.loading) return;
      this.loading = true;
      try {
        await fetch(`${config.API_BASE_URL}/prolific/session/${this.sessionId}/video/complete/`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({}),
        });
        this.$router.replace(`/prolific/study/${this.sessionId}/practice`);
      } catch (e) {
        console.error(e);
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.training-video {
  width: 100%;
  max-height: 70vh;
  background: #000;
  display: block;
}
</style>
